import { render, staticRenderFns } from "./Preview3d.vue?vue&type=template&id=5b3c1a20&scoped=true"
import script from "./Preview3d.vue?vue&type=script&lang=js"
export * from "./Preview3d.vue?vue&type=script&lang=js"
import style0 from "./Preview3d.vue?vue&type=style&index=0&id=5b3c1a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c1a20",
  null
  
)

export default component.exports